
/* injects from baggage-loader */

'use strict';

import ProductEditController from './product.edit.controller';
import ProductEditTemplate from './product.edit.html';

export default class ProductEditComponent {
		constructor() {
				this.templateUrl = ProductEditTemplate;
				this.controller = ProductEditController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					product: '<',
					documents: '<'
				};
		}
}
